/**
 * Format des Faits relevés par le SDK pendant une session (voir `CONTEXT.md`) : un événement
 * rrweb de plugin (`type: 6`, `data: { plugin: INTERACTIONS_PLUGIN, payload: FaitInteraction }`)
 * par Fait, dans le flux du Recording. Le lecteur les ignore ; l'API les relit pour apprendre les
 * Règles d'un projet.
 *
 * Un Fait ne contient jamais de valeur saisie : seulement la Signature des éléments, faite de
 * libellés déjà visibles dans l'enregistrement et masquée comme lui (`.belvdr-mask`).
 */
/** Nom du plugin des Faits du SDK dans les événements rrweb. */
export const INTERACTIONS_PLUGIN = 'belvdr/interactions@1';
/** Longueur maximale du nom et du contexte d'une Signature, après normalisation. */
export const MAX_SIGNATURE_TEXT_LENGTH = 60;
/** Texte d'une Signature sous `.belvdr-mask` : il n'est jamais relevé. */
export const MASKED_SIGNATURE_TEXT = '•';
/**
 * Clé texte d'une Signature, lisible et stable : `button « Ajouter au panier » dans « Carte de
 * Cassini »`, `paragraph #confirmation`. Sert de clé d'apprentissage et de libellé.
 */
export function cleDeSignature(signature) {
    return [
        signature.role,
        signature.id === undefined ? null : `#${signature.id}`,
        signature.testId === undefined ? null : `[${signature.testId}]`,
        signature.nom === undefined ? null : `« ${signature.nom} »`,
        signature.contexte === undefined ? null : `dans « ${signature.contexte} »`,
    ]
        .filter((part) => part !== null)
        .join(' ');
}
/** Forme d'une clé de Signature : rôle, `#id`, `[testId]`, `« nom »`, `dans « contexte »`. */
const CLE_DE_SIGNATURE = /^(\S+)(?: #(\S+))?(?: \[([^\]]+)\])?(?: « (.*?) »)?(?: dans « (.*) »)?$/;
/**
 * Signature d'une clé produite par `cleDeSignature`, ou `null` si elle est malformée. Sert aux
 * scénarios générés : retrouver l'élément d'une Action à partir de sa clé.
 */
export function signatureDeCle(cle) {
    const match = CLE_DE_SIGNATURE.exec(cle.trim());
    if (!match)
        return null;
    const [, role, id, testId, nom, contexte] = match;
    const signature = { role: role };
    if (id !== undefined)
        signature.id = id;
    if (testId !== undefined)
        signature.testId = testId;
    if (nom !== undefined)
        signature.nom = nom;
    if (contexte !== undefined)
        signature.contexte = contexte;
    return signature;
}
